import { Component } from '@angular/core';

@Component({
  selector: 'app-call-offer-alerts',
  templateUrl: './call-offer-alerts.component.html',
  styleUrls: ['./call-offer-alerts.component.css']
})
export class CallOfferAlertsComponent {



}
